import React, { Component } from 'react'
import styled from 'styled-components'

class ActivityThree extends Component {
  render() {
    return (
      <RootView>
        <BgImage src={require('./images/activity-content-three.png')} />
      </RootView>
    )
  }
}

export default ActivityThree

const RootView = styled.div`
    background-color: white;
    flex-direction:column;
    width:100%;
    height:100%;
  `
const BgImage = styled.img`
    width:100%;
  `



// WEBPACK FOOTER //
// ./src/modules/activity/components/activityThree.js